import axios from 'axios';
import { setupRequestInterceptor, setupResponseInterceptor } from './interceptors';

// Create axios instance with default configuration
const axiosInstance = axios.create({
  baseURL: import.meta.env.VITE_REALTIME_API_URL || 'http://localhost:4200',
  timeout: 0,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Setup interceptors
setupRequestInterceptor(axiosInstance);
setupResponseInterceptor(axiosInstance);

export default axiosInstance; 